export default (xScale, totalDistance) => (selection) => {
  selection.selectAll('.drop-line').remove();

  const domain = xScale.domain();
  const dropLine = selection.selectAll('.drop-line').data([totalDistance]);
  dropLine
    .enter()
    .append('line')
    .classed('drop-line', true)
    .attr('x1', () => {
      let returnVal = null;
      if (domain[1] >= 0) {
        returnVal = domain[0] >= 0 ? xScale(domain[0]) : xScale(0);
      }

      if (domain[1] < 0) {
        returnVal = domain[1] < 0 ? xScale(domain[1]) : xScale(0);
      }
      return returnVal;
    })
    .attr('y1', 37.5)
    .attr('x2', (d) => {
      let returnVal = null;
      if (d > domain[0]) {
        returnVal = d <= domain[1] ? xScale(d) : xScale(domain[1]);
      }

      if (d <= domain[0]) {
        returnVal = d <= domain[0] ? xScale(domain[0]) : xScale(d);
      }
      return returnVal;
    })
    .attr('y2', 37.5)
    .style('stroke-width', 2)
    .style('stroke', '#BDBDBD');

  return dropLine;
};



// WEBPACK FOOTER //
// ./src/views/pages/completion/dropLine.js